import Vue from 'vue';
import App from './App.vue';
import router from './router/router.js';
import store from './store/store.js';
import BootstrapVue from 'bootstrap-vue';
import VueToast from 'vue-toast-notification';

Vue.use(VueToast, {
	position: 'top-right',
	duration: 10000,
	queue: true,
	onClose: function toastClose() {},
});
Vue.use(BootstrapVue);

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-toast-notification/dist/theme-sugar.css';
import './registerServiceWorker'

new Vue({
	router,
	store,
	render: (h) => h(App),
	methods: {},
	created: function () {},
}).$mount('#app');

Vue.config.productionTip = false;
/*Vue.$cookies.config('30d', '/', process.env.VUE_APP_DOMAIN, '', 'Lax');*/
